import { errorMessages } from "../constants/frontendErrorMessages";
import { USER_INPUT_FIELD_TYPES } from "../constants/userInputFieldNames";

// Validate email
const validateEmail = (email) => {

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!emailRegex.test(email)) return errorMessages.INVALID_EMAIL;
    return ""
};
  
// Validate phone number
const validatePhone = (phone) => {

    const phoneRegex = /^\+?\d{10,15}$/;
  
    if (!phone) {
      return errorMessages.REQUIRED_FIELD;
    } else if (!phoneRegex.test(phone)) {
      return errorMessages.INVALID_PHONE_NUMBER; 
    }
  
    return ""; 
};

  // Validate email or phone number
const validateEmailOrPhone = (input) => {

    if (!input) {
      return errorMessages.REQUIRED_FIELD;
    } else if (validateEmail(input)) {
      return "";
    } else if (validatePhone(input) === "") {
      return "";
    }

    return errorMessages.INVALID_EMAIL_OR_PHONE;

};
  
// Validate password
const validatePassword = (password) => {

    const hasMinLength = password.length >= 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    
    if(!hasMinLength || !hasUpperCase || !hasLowerCase || !hasSpecialChar){
      return errorMessages.INVALID_PASSWORD;
    }
    return ""

    return "";
};

// valdiate an number
const  isValidNumber = (input) => {
  // Check if the input is of type "number" or can be converted to a valid number
  if (typeof input === 'number' && !isNaN(input)) {
      return "";
  }
  if (typeof input === 'string' && !isNaN(parseFloat(input)) && isFinite(input)) {
      return "";
  }
  return errorMessages.INVALID_NUMBER;
}

// Validate fieldsa
export const validateField = (name, type, value, formData, requiredFields) => {
  
    if(!type) return 'Error';

    let error = "";    

    switch (type) {

      case USER_INPUT_FIELD_TYPES.REQUIRED_FIELD:
        if (!value && requiredFields[name] && value !== 0) error = errorMessages.REQUIRED_FIELD;
        break;

      case USER_INPUT_FIELD_TYPES.BOOLEAN_FIELD:
        if ((!value && value !== false) && requiredFields[name]) error = errorMessages.REQUIRED_FIELD;
        else if (!(!value && value !== false) && !(value === false || value === true)) error = errorMessages.INVALID_OPTION;
        break;

      case USER_INPUT_FIELD_TYPES.NUMBER_FIELD:
        if ((!value && value !== false) && requiredFields[name]) error = errorMessages.REQUIRED_FIELD;
        else if (value) error = isValidNumber(value);
        break;

      case USER_INPUT_FIELD_TYPES.FIRST_NAME:
        if (!value && requiredFields[name]) error = errorMessages.REQUIRED_FIELD;
        break;

      case USER_INPUT_FIELD_TYPES.LAST_NAME:
        if (!value && requiredFields[name]) error = errorMessages.REQUIRED_FIELD;
        break;

      case USER_INPUT_FIELD_TYPES.EMAIL:
        if (!value && requiredFields[name]) error = errorMessages.REQUIRED_FIELD;
        else if (value) error = validateEmail(value);
        break;

      case USER_INPUT_FIELD_TYPES.PHONE:
        if (!value && requiredFields[name]) error = errorMessages.REQUIRED_FIELD;
        else if (value) error = validatePhone(value);
        break;

      case USER_INPUT_FIELD_TYPES.PASSWORD:
        if (!value && requiredFields[name]) error = errorMessages.REQUIRED_FIELD;
        else if (value) error = validatePassword(value);
        break;

      case USER_INPUT_FIELD_TYPES.CONFIRM_PASSWORD:
        if (!value && requiredFields[name]) error = errorMessages.REQUIRED_FIELD;
        else if (value !== formData.password ) error = errorMessages.PASSWORD_MISMATCH;
        break;

      case USER_INPUT_FIELD_TYPES.MIN_30_CHARACTORS:
        if (!value && requiredFields[name]) error = errorMessages.REQUIRED_FIELD;
        else if(value.length < 30) error = errorMessages.CHARACTOR_LENGTH_30
        break
        
      default:
        break;

    }

    return error;
};
  
